<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';

import UploadComponent from '../../components/upload/Upload.vue';
import useI18NAsync from '~/composables/i18nAsync';

// VARIABLES
const i18nSuspense = useI18NAsync('pages/upload');

const baseUrl = ref('');
const random = Math.floor(Math.random() * 4) + 1;
const randomBackground = computed(
  () => `${baseUrl.value}MP3DPMakeVue3/assets/images/upload/upload_background_0${random}.jpg`,
);

onMounted(async () => {
  baseUrl.value = window.dsDefaultWebappsBaseUrl;
});
</script>

<template>
  <div
    class="quote-upload flex align-items-center justify-center pa-20px--md pa-0px--sm"
    :style="`background-image: url(${randomBackground});`"
  >
    <div class="quote-upload-content-container pt-30px pt-0px--sm">
      <UploadComponent
        :display-upload-butons="true"
        :display-shared-parts="true"
        :display-upload-features="true"
        :display-delivery-date="false"
      >
        <template #title>
          <h1 class="mt-10px title">
            <i18nSuspense ikey="title" />
          </h1>
        </template>
      </UploadComponent>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

.title {
  font-size: 24px;
}

.quote-upload {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}

.quote-upload-content-container {
  width: 100%;
  max-width: 1084px;
  box-shadow: 12px 12px 34px 12px rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  margin: auto;
  background-color: white;

  @include variables.for-xs {
    border-radius: 0;
  }
}
</style>
